module.exports = __webpack_public_path__ + "media/images/favicon-cbb3dc5d2e52b4a12dd5abf68607dc10.png";